import { watch } from "vue"

/**
 * Applies a watch to the people array to ensure the first attendee is set if the people array is emptied at any point
 * 
 * @param {Object} form 
 */
export function createFormFieldPeopleWatch(form){
    watch(() => form.fields.value.ticket.people, (newPeople) => {
        if(newPeople === undefined){
            return
        }

        if(newPeople.length > 0){
            form.fields.value.ticket.people[0].forename = form.fields.value.forename
            form.fields.value.ticket.people[0].middle_name = form.fields.value.middle_name
            form.fields.value.ticket.people[0].surname = form.fields.value.surname
            form.fields.value.ticket.people[0].email = form.fields.value.contact.email
        }

    }, { deep: true })
}